import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-player-tag',
  templateUrl: './player-tag.component.html',
  styleUrls: ['./player-tag.component.scss']
})
export class PlayerTagComponent {

  @Input()
  player;

  constructor() { }

}